import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'status',
    state: {
        kurir: [],
    },
    getters: {
        getAllKurir: state => {
            return state.kurir
        },
    },
    mutations: {
        GET_ALL_KURIR: (state, payload) => {
            state.kurir = payload
        }
    },
    actions: {
        async FETCH_ALL_KURIR(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "po/kurir",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('GET_ALL_KURIR', response.data.data);
                return store.state.kurir;
            })
                .catch(err => {
                    return err
                });
        },
    }
}